import { type ReactNode } from 'react';
import { PrivyProvider as BasePrivyProvider } from '@privy-io/react-auth';
import { privy } from '@/config';

interface PrivyProviderProps {
  children: ReactNode;
}

export function PrivyProvider({ children }: PrivyProviderProps) {
  // Get configuration from centralized config (validation happens there)
  const { appId, clientId } = privy;

  return (
    <BasePrivyProvider
      appId={appId}
      clientId={clientId}
      config={{
        loginMethods: ['sms'],
        embeddedWallets: {
          ethereum: {
            createOnLogin: 'users-without-wallets',
          },
          solana: {
            createOnLogin: 'users-without-wallets',
          },
        },
      }}
    >
      {children}
    </BasePrivyProvider>
  );
}
